import React, { useState } from 'react';
import {
  Input,
  InputNumber,
  Select,
  Form,
  Button,
  Modal,
  Tag as AntdTag,
} from 'antd';
import cx from 'classnames';
import styles from './feeds.module.sass';
import tagStyles from '../../../../shared-components/Tag/tag.module.sass';
import GeneralTagMultipleSelect from '../../../../shared-components/GeneralTagMultipleSelect';
import { incrementUIRequestsCounter } from '../../../../redux/utils/websocket/incrementUIRequestsCounter';
import { useDispatch } from 'react-redux';

function CreateEmptyFeedModal(props) {
  const [form] = Form.useForm();
  const [enableSaveButton, setEnableSaveButton] = useState(false);
  const [editingTags, setEditingTags] = useState(false);
  const dispatch = useDispatch();

  const CreateEmptyFeed = (formValues) => {
    let data = {
      state: props.state.toUpperCase(),
      name: formValues?.feed_name,
      threat_type: formValues?.feed_type,
      custom_score: formValues?.feed_custom_score,
      vendor: formValues?.feed_vendor,
      feed_description: formValues?.feed_description,
    };
    if (sessionStorage?.getItem('tags')) {
      data = { ...data, tags: JSON.parse(sessionStorage?.getItem('tags')) };
    }
    props.createEmptySource(data);
    incrementUIRequestsCounter();
  };

  const handleContainerClick = () => {
    setEditingTags(true);
  };

  const handleRemoveTagClick = (tagName) => {
    let updatedTags = JSON.parse(sessionStorage?.getItem('tags'))?.filter(
      (tag) => tag !== tagName,
    );
    sessionStorage.setItem('tags', JSON.stringify(updatedTags));
  };

  const handleBlur = () => {
    props.resetTagSearch();
    setEditingTags(false);
  };

  const onInputChange = () => {
    let feed_name = form.getFieldValue('feed_name');
    let feed_type = form.getFieldValue('feed_type');
    if (feed_name && feed_type) {
      setEnableSaveButton(true);
    } else {
      setEnableSaveButton(false);
    }
  };

  const onSave = () => {
    let formValues = form.getFieldsValue();
    form.validateFields().then(() => {
      CreateEmptyFeed(formValues);
      props.onCreate();
    });
  };

  const getModalTitle = () => {
    if (props?.state.toUpperCase() === 'COLLECTION') {
      return 'Create empty collection';
    } else {
      return 'Create empty feed';
    }
  };

  const getSourceNameFieldName = () => {
    if (props?.state.toUpperCase() === 'COLLECTION') {
      return 'Collection name';
    }
    return 'Feed name';
  };

  const getSourceNameFieldPlaceHolder = () => {
    if (props?.state.toUpperCase() === 'COLLECTION') {
      return 'Enter collection name';
    }
    return 'Enter feed name';
  };

  const getSourceTypeFieldName = () => {
    if (props?.state.toUpperCase() === 'COLLECTION') {
      return 'Collection type';
    }
    return 'Feed type';
  };

  const getSourceTypeFieldPlaceHolder = () => {
    if (props?.state.toUpperCase() === 'COLLECTION') {
      return 'Select collection type';
    }
    return 'Select feed type';
  };

  return (
    <Modal
      title={getModalTitle()}
      className="empty_feed_modal"
      visible={true}
      maskClosable={false}
      onCancel={() => props.onCancel()}
      footer={[
        <Button
          style={{
            color: 'rgb(60, 154, 232)',
            border: '1px solid rgb(60, 154, 232)',
          }}
          key="cancel"
          onClick={() => {
            props.onCancel(false);
            form.resetFields();
          }}
        >
          Cancel
        </Button>,
        <Button
          key="submit"
          disabled={!enableSaveButton}
          type="primary"
          onClick={onSave}
        >
          Create
        </Button>,
      ]}
    >
      <Form form={form} name="feed" initialValues={{}}>
        <p
          style={{
            position: 'absolute',
            top: '30px',
            left: '16px',
            fontStyle: 'normal',
            fontSize: '14px',
            lineHeight: '19px',
            color: 'rgba(255, 255, 255, 0.85)',
          }}
        >
          {getSourceNameFieldName()} <span style={{ color: 'red' }}>*</span>
        </p>
        <div
          style={{
            marginTop: '10px',
            position: 'absolute',
            top: '45px',
            left: '16px',
          }}
        >
          <Form.Item
            name="feed_name"
            rules={[
              {
                required: true,
                message: 'Name is a required field.',
              },
            ]}
          >
            <Input
              maxLength={150}
              style={{
                minWidth: 340,
                maxWidth: 340,
                border: '1px solid rgba(255, 255, 255, 0.2)',
              }}
              placeholder={getSourceNameFieldPlaceHolder()}
              onChange={onInputChange}
            />
          </Form.Item>
        </div>

        <p
          style={{
            position: 'absolute',
            top: '30px',
            left: '380px',
            fontStyle: 'normal',
            fontSize: '14px',
            lineHeight: '19px',
            color: 'rgba(255, 255, 255, 0.85)',
          }}
        >
          {getSourceTypeFieldName()} <span style={{ color: 'red' }}>*</span>
        </p>
        <div
          style={{
            marginTop: '10px',
            position: 'absolute',
            top: '45px',
            left: '380px',
          }}
        >
          <Form.Item
            name="feed_type"
            rules={[
              {
                required: true,
                message: 'Type is a required field.',
              },
            ]}
          >
            <Select
              allowClear
              placeholder={getSourceTypeFieldPlaceHolder()}
              style={{
                minWidth: 200,
                maxWidth: 200,
              }}
              onChange={onInputChange}
            >
              <Select.Option value="ip">IP</Select.Option>
              <Select.Option value="domain">Domain</Select.Option>
              <Select.Option value="url">URL</Select.Option>
            </Select>
          </Form.Item>
        </div>

        <p
          style={{
            position: 'absolute',
            top: '30px',
            left: '596px',
            fontStyle: 'normal',
            fontSize: '14px',
            lineHeight: '19px',
            color: 'rgba(255, 255, 255, 0.85)',
          }}
        >
          Vendor
        </p>
        <div
          style={{
            marginTop: '10px',
            position: 'absolute',
            top: '45px',
            left: '596px',
          }}
        >
          <Form.Item
            name="feed_vendor"
            rules={[
              {
                required: false,
                message: 'Please input the vendor name!',
              },
            ]}
          >
            <Input
              maxLength={250}
              style={{
                minWidth: 350,
                maxWidth: 350,
                border: '1px solid rgba(255, 255, 255, 0.2)',
              }}
              placeholder="Enter Vendor Name"
            />
          </Form.Item>
        </div>

        <p
          style={{
            position: 'absolute',
            top: '30px',
            left: '965px',
            fontStyle: 'normal',
            fontSize: '14px',
            lineHeight: '19px',
            color: 'rgba(255, 255, 255, 0.85)',
          }}
        >
          Source Score (0-100)
        </p>
        <div
          style={{
            marginTop: '10px',
            position: 'absolute',
            top: '45px',
            left: '965px',
          }}
        >
          <Form.Item
            name="feed_custom_score"
            rules={[
              {
                required: false,
                message: 'Source score is a required field.',
              },
            ]}
          >
            <InputNumber
              min={0}
              max={100}
              style={{
                minWidth: 210,
                maxWidth: 210,
                border: '1px solid rgba(255, 255, 255, 0.2)',
              }}
              placeholder="Enter Source Score"
            />
          </Form.Item>
        </div>

        <p
          style={{
            position: 'absolute',
            top: '116px',
            left: '16px',
            fontStyle: 'normal',
            fontSize: '14px',
            lineHeight: '19px',
            color: 'rgba(255, 255, 255, 0.85)',
          }}
        >
          Description
        </p>
        <div
          style={{
            position: 'absolute',
            top: '141px',
            left: '16px',
          }}
        >
          <Form.Item
            name="feed_description"
            rules={[
              {
                required: false,
                message: 'Please input the description!',
              },
            ]}
          >
            <Input.TextArea
              rows={4}
              maxLength={3000}
              style={{
                minWidth: 1160,
                maxWidth: 1160,
                border: '1px solid rgba(255, 255, 255, 0.2)',
              }}
              placeholder="Enter Description"
            />
          </Form.Item>
        </div>

        <div
          className={styles?.tag_list}
          style={{
            position: 'relative',
            top: '230px',
          }}
        >
          {editingTags ? (
            <>
              {sessionStorage?.getItem('tags')
                ? JSON.parse(sessionStorage?.getItem('tags'))?.map((tag) => {
                    return (
                      <AntdTag
                        key={`${Math.random()}`}
                        onClose={() => handleRemoveTagClick(tag)}
                        className={cx(styles?.manually_tag)}
                        closable={true}
                      >
                        {tag?.name ? tag?.name : tag}
                      </AntdTag>
                    );
                  })
                : ''}
              <GeneralTagMultipleSelect
                foundTags={props?.foundTags}
                searchStatus={props?.searchStatus}
                searchForTags={props?.searchForTags}
                onBlur={() => handleBlur()}
                clearValue
              />
            </>
          ) : (
            <>
              {sessionStorage?.getItem('tags')
                ? JSON.parse(sessionStorage?.getItem('tags'))?.map((tag) => {
                    return (
                      <AntdTag
                        key={`${Math.random()}`}
                        onClose={() => handleRemoveTagClick(tag)}
                        className={cx(styles?.manually_tag)}
                        closable={true}
                      >
                        {tag?.name ? tag?.name : tag}
                      </AntdTag>
                    );
                  })
                : ''}
              <AntdTag
                role={'button13'}
                className={cx(tagStyles?.tag, styles?.add_btn)}
                onClick={() => handleContainerClick()}
              >
                + Add Tag
              </AntdTag>
            </>
          )}
        </div>
      </Form>
    </Modal>
  );
}

export default CreateEmptyFeedModal;
